export default [
  {
    "code": "1365",
    "genre-ko": "액션 & 어드벤쳐",
    "genre-en": "Action & Adventure"
  },
  {
    "code": "43040",
    "genre-ko": "액션 코메디",
    "genre-en": "Action Comedies"
  },
  {
    "code": "1568",
    "genre-ko": "액션 공상과학 & 판타지",
    "genre-en": "Action Sci-Fi & Fantasy"
  },
  {
    "code": "43048",
    "genre-ko": "액션 스릴러",
    "genre-en": "Action Thrillers"
  },
  {
    "code": "11881",
    "genre-ko": "성인 애니메이션",
    "genre-en": "Adult Animation"
  },
  {
    "code": "7442",
    "genre-ko": "모험",
    "genre-en": "Adventures"
  },
  {
    "code": "3761",
    "genre-ko": "아프리카 영화",
    "genre-en": "African Movies"
  },
  {
    "code": "3327",
    "genre-ko": "에어리언 공상과학",
    "genre-en": "Alien Sci-Fi"
  },
  {
    "code": "5507",
    "genre-ko": "동물 이야기",
    "genre-en": "Animal Tales"
  },
  {
    "code": "7424",
    "genre-ko": "애니메이션",
    "genre-en": "Anime"
  },
  {
    "code": "2653",
    "genre-ko": "애니메이션 액션",
    "genre-en": "Anime Action"
  },
  {
    "code": "9302",
    "genre-ko": "애니메이션 코메디",
    "genre-en": "Anime Comedies"
  },
  {
    "code": "452",
    "genre-ko": "애니메이션 드라마",
    "genre-en": "Anime Dramas"
  },
  {
    "code": "11146",
    "genre-ko": "애니메이션 판타지",
    "genre-en": "Anime Fantasy"
  },
  {
    "code": "3063",
    "genre-ko": "애니메이션 장편",
    "genre-en": "Anime Features"
  },
  {
    "code": "10695",
    "genre-ko": "애니메이션 공포",
    "genre-en": "Anime Horror"
  },
  {
    "code": "2729",
    "genre-ko": "애니메이션 공상과학",
    "genre-en": "Anime Sci-Fi"
  },
  {
    "code": "6721",
    "genre-ko": "애니메이션 시리즈",
    "genre-en": "Anime Series"
  },
  {
    "code": "29764",
    "genre-ko": "예술 영화",
    "genre-en": "Art House Movies"
  },
  {
    "code": "77232",
    "genre-ko": "동양 액션 영화",
    "genre-en": "Asian Action Movies"
  },
  {
    "code": "5230",
    "genre-ko": "호주 영화",
    "genre-en": "Australian Movies"
  },
  {
    "code": "8195",
    "genre-ko": "B급 공포 영화",
    "genre-en": "B-Horror Movies"
  },
  {
    "code": "12339",
    "genre-ko": "야구 영화",
    "genre-en": "Baseball Movies"
  },
  {
    "code": "12762",
    "genre-ko": "농구 영화",
    "genre-en": "Basketball Movies"
  },
  {
    "code": "262",
    "genre-ko": "벨기에 영화",
    "genre-en": "Belgian Movies"
  },
  {
    "code": "3652",
    "genre-ko": "실존인물 다큐",
    "genre-en": "Biographical Documentaries"
  },
  {
    "code": "3179",
    "genre-ko": "실존인물 드라마",
    "genre-en": "Biographical Dramas"
  },
  {
    "code": "12443",
    "genre-ko": "복싱 영화",
    "genre-en": "Boxing Movies"
  },
  {
    "code": "10757",
    "genre-ko": "영국 영화",
    "genre-en": "British Movies"
  },
  {
    "code": "52117",
    "genre-ko": "영국 TV Show",
    "genre-en": "British TV Shows"
  },
  {
    "code": "1252",
    "genre-ko": "과장스러운 영화",
    "genre-en": "Campy Movies"
  },
  {
    "code": "783",
    "genre-ko": "어린이 & 가족 영화",
    "genre-en": "Children & Family Movies"
  },
  {
    "code": "3960",
    "genre-ko": "중국 영화",
    "genre-en": "Chinese Movies"
  },
  {
    "code": "46576",
    "genre-ko": "고전 액션 & 어드벤쳐",
    "genre-en": "Classic Action & Adventure"
  },
  {
    "code": "31694",
    "genre-ko": "고전 코메디",
    "genre-en": "Classic Comedies"
  },
  {
    "code": "29809",
    "genre-ko": "고전 드라마",
    "genre-en": "Classic Dramas"
  },
  {
    "code": "32473",
    "genre-ko": "고전 외국 영화",
    "genre-en": "Classic Foreign Movies"
  },
  {
    "code": "31574",
    "genre-ko": "고전 영화",
    "genre-en": "Classic Movies"
  },
  {
    "code": "32392",
    "genre-ko": "고전 뮤지컬",
    "genre-en": "Classic Musicals"
  },
  {
    "code": "31273",
    "genre-ko": "고전 로맨틱 영화",
    "genre-en": "Classic Romantic Movies"
  },
  {
    "code": "47147",
    "genre-ko": "고전 공상과학 & 판타지",
    "genre-en": "Classic Sci-Fi & Fantasy"
  },
  {
    "code": "46588",
    "genre-ko": "고전 스릴러",
    "genre-en": "Classic Thrillers"
  },
  {
    "code": "46553",
    "genre-ko": "고전 TV Show",
    "genre-en": "Classic TV Shows"
  },
  {
    "code": "48744",
    "genre-ko": "고전 전쟁 영화",
    "genre-en": "Classic War Movies"
  },
  {
    "code": "47465",
    "genre-ko": "고전 서부",
    "genre-en": "Classic Westerns"
  },
  {
    "code": "6548",
    "genre-ko": "코메디",
    "genre-en": "Comedies"
  },
  {
    "code": "10118",
    "genre-ko": "코믹북 & 슈퍼히어로",
    "genre-en": "Comic Book and Superhero Movies"
  },
  {
    "code": "1105",
    "genre-ko": "컨트리 & 웨스턴/폴크스",
    "genre-en": "Country & Western/Folk"
  },
  {
    "code": "2748",
    "genre-ko": "법정 영화 드라마",
    "genre-en": "Courtroom Dramas"
  },
  {
    "code": "6895",
    "genre-ko": "괴수 영화",
    "genre-en": "Creature Features"
  },
  {
    "code": "9584",
    "genre-ko": "범죄 액션 & 어드벤쳐",
    "genre-en": "Crime Action & Adventure"
  },
  {
    "code": "9875",
    "genre-ko": "범죄 다큐",
    "genre-en": "Crime Documentaries"
  },
  {
    "code": "6889",
    "genre-ko": "범죄 드라마",
    "genre-en": "Crime Dramas"
  },
  {
    "code": "10499",
    "genre-ko": "범죄 스릴러",
    "genre-en": "Crime Thrillers"
  },
  {
    "code": "26146",
    "genre-ko": "범죄 TV Show",
    "genre-en": "Crime TV Shows"
  },
  {
    "code": "9434",
    "genre-ko": "컬트 코메디",
    "genre-en": "Cult Comedies"
  },
  {
    "code": "10944",
    "genre-ko": "컬트 공포",
    "genre-en": "Cult Horror Movies"
  },
  {
    "code": "7627",
    "genre-ko": "컬트 영화",
    "genre-en": "Cult Movies"
  },
  {
    "code": "4734",
    "genre-ko": "컬트 공상과학 & 판타지",
    "genre-en": "Cult Sci-Fi & Fantasy"
  },
  {
    "code": "74652",
    "genre-ko": "컬트 TV Show",
    "genre-en": "Cult TV Shows"
  },
  {
    "code": "869",
    "genre-ko": "블랙 코메디",
    "genre-en": "Dark Comedies"
  },
  {
    "code": "45028",
    "genre-ko": "심해 호러",
    "genre-en": "Deep Sea Horror Movies"
  },
  {
    "code": "67673",
    "genre-ko": "디즈니",
    "genre-en": "Disney"
  },
  {
    "code": "59433",
    "genre-ko": "디즈니 뮤지컬",
    "genre-en": "Disney Musicals"
  },
  {
    "code": "6839",
    "genre-ko": "다큐",
    "genre-en": "Documentaries"
  },
  {
    "code": "5763",
    "genre-ko": "드라마",
    "genre-en": "Dramas"
  },
  {
    "code": "4961",
    "genre-ko": "도서원작 드라마",
    "genre-en": "Dramas based on Books"
  },
  {
    "code": "3653",
    "genre-ko": "실화바탕 드라마",
    "genre-en": "Dramas based on real life"
  },
  {
    "code": "10606",
    "genre-ko": "네덜란드 영화",
    "genre-en": "Dutch Movies"
  },
  {
    "code": "5254",
    "genre-ko": "동유럽 영화",
    "genre-en": "Eastern European Movies"
  },
  {
    "code": "10659",
    "genre-ko": "어린이 교육",
    "genre-en": "Education for Kids"
  },
  {
    "code": "52858",
    "genre-ko": "서사시",
    "genre-en": "Epics"
  },
  {
    "code": "11079",
    "genre-ko": "실험 영화",
    "genre-en": "Experimental Movies"
  },
  {
    "code": "26835",
    "genre-ko": "신앙 & 영성",
    "genre-en": "Faith & Spirituality"
  },
  {
    "code": "52804",
    "genre-ko": "신앙 & 영성 영화",
    "genre-en": "Faith & Spirituality Movies"
  },
  {
    "code": "51056",
    "genre-ko": "가족 장편",
    "genre-en": "Family Features"
  },
  {
    "code": "9744",
    "genre-ko": "판타지 영화",
    "genre-en": "Fantasy Movies"
  },
  {
    "code": "7687",
    "genre-ko": "누아르 영화",
    "genre-en": "Film Noir"
  },
  {
    "code": "72436",
    "genre-ko": "음식 & 여행 TV",
    "genre-en": "Food & Travel TV"
  },
  {
    "code": "12803",
    "genre-ko": "풋볼 영화",
    "genre-en": "Football Movies"
  },
  {
    "code": "11828",
    "genre-ko": "외국 액션 & 어드벤쳐",
    "genre-en": "Foreign Action & Adventure"
  },
  {
    "code": "4426",
    "genre-ko": "외국 코메디",
    "genre-en": "Foreign Comedies"
  },
  {
    "code": "5161",
    "genre-ko": "외국 다큐",
    "genre-en": "Foreign Documentaries"
  },
  {
    "code": "2150",
    "genre-ko": "외국 드라마",
    "genre-en": "Foreign Dramas"
  },
  {
    "code": "8243",
    "genre-ko": "외국 게이 & 레즈비언 영화",
    "genre-en": "Foreign Gay & Lesbian Movies"
  },
  {
    "code": "8654",
    "genre-ko": "외국 공포 영화",
    "genre-en": "Foreign Horror Movies"
  },
  {
    "code": "7462",
    "genre-ko": "외국 영화",
    "genre-en": "Foreign Movies"
  },
  {
    "code": "6485",
    "genre-ko": "외국 공상과학 & 판타지",
    "genre-en": "Foreign Sci-Fi & Fantasy"
  },
  {
    "code": "10306",
    "genre-ko": "외국 스릴러",
    "genre-en": "Foreign Thrillers"
  },
  {
    "code": "58807",
    "genre-ko": "프랑스 영화",
    "genre-en": "French Movies"
  },
  {
    "code": "31851",
    "genre-ko": "갱스터 영화",
    "genre-en": "Gangster Movies"
  },
  {
    "code": "500",
    "genre-ko": "게이 & 레즈비언 드라마",
    "genre-en": "Gay & Lesbian Dramas"
  },
  {
    "code": "58886",
    "genre-ko": "독일 영화",
    "genre-en": "German Movies"
  },
  {
    "code": "61115",
    "genre-ko": "그리스 영화",
    "genre-en": "Greek Movies"
  },
  {
    "code": "5349",
    "genre-ko": "역사 다큐",
    "genre-en": "Historical Documentaries"
  },
  {
    "code": "89585",
    "genre-ko": "공포 코메디",
    "genre-en": "Horror Comedy"
  },
  {
    "code": "8711",
    "genre-ko": "공포 영화",
    "genre-en": "Horror Movies"
  },
  {
    "code": "11804",
    "genre-ko": "독립 액션 & 어드벤쳐",
    "genre-en": "Independent Action & Adventure"
  },
  {
    "code": "4195",
    "genre-ko": "독립 코메디",
    "genre-en": "Independent Comedies"
  },
  {
    "code": "384",
    "genre-ko": "독립 드라마",
    "genre-en": "Independent Dramas"
  },
  {
    "code": "7077",
    "genre-ko": "독립 영화",
    "genre-en": "Independent Movies"
  },
  {
    "code": "3269",
    "genre-ko": "독립 스릴러",
    "genre-en": "Independent Thrillers"
  },
  {
    "code": "10463",
    "genre-ko": "인도 영화",
    "genre-en": "Indian Movies"
  },
  {
    "code": "58750",
    "genre-ko": "아일랜드 영화",
    "genre-en": "Irish Movies"
  },
  {
    "code": "8221",
    "genre-ko": "이탈리안 영화",
    "genre-en": "Italian Movies"
  },
  {
    "code": "10398",
    "genre-ko": "일본 영화",
    "genre-en": "Japanese Movies"
  },
  {
    "code": "10271",
    "genre-ko": "재즈 & 듣기편한",
    "genre-en": "Jazz & Easy Listening"
  },
  {
    "code": "751423",
    "genre-ko": "어린이 신앙 & 영성",
    "genre-en": "Kids Faith & Spirituality"
  },
  {
    "code": "52843",
    "genre-ko": "어린이 음악",
    "genre-en": "Kids Music"
  },
  {
    "code": "27346",
    "genre-ko": "어린이 TV",
    "genre-en": "Kids TV"
  },
  {
    "code": "5685",
    "genre-ko": "한국 영화",
    "genre-en": "Korean Movies"
  },
  {
    "code": "67879",
    "genre-ko": "한국 TV Show",
    "genre-en": "Korean TV Shows"
  },
  {
    "code": "1402",
    "genre-ko": "심야 코메디",
    "genre-en": "Late Night Comedies"
  },
  {
    "code": "1613",
    "genre-ko": "라틴 아메리카 영화",
    "genre-en": "Latin American Movies"
  },
  {
    "code": "10741",
    "genre-ko": "라틴 음악",
    "genre-en": "Latin Music"
  },
  {
    "code": "8985",
    "genre-ko": "무술 영화",
    "genre-en": "Martial Arts Movies"
  },
  {
    "code": "6695",
    "genre-ko": "무술 복싱 & 레슬링",
    "genre-en": "Martial Arts, Boxing & Wrestling"
  },
  {
    "code": "5875",
    "genre-ko": "중동 영화",
    "genre-en": "Middle Eastern Movies"
  },
  {
    "code": "2125",
    "genre-ko": "군사 액션 & 어드벤쳐",
    "genre-en": "Military Action & Adventure"
  },
  {
    "code": "4006",
    "genre-ko": "군사 다큐멘터리",
    "genre-en": "Military Documentaries"
  },
  {
    "code": "11",
    "genre-ko": "군사 드라마",
    "genre-en": "Military Dramas"
  },
  {
    "code": "25804",
    "genre-ko": "군사 TV Show",
    "genre-en": "Military TV Shows"
  },
  {
    "code": "4814",
    "genre-ko": "미니시리즈",
    "genre-en": "Miniseries"
  },
  {
    "code": "26",
    "genre-ko": "모큐멘터리",
    "genre-en": "Mockumentaries"
  },
  {
    "code": "947",
    "genre-ko": "괴물 영화",
    "genre-en": "Monster Movies"
  },
  {
    "code": "10056",
    "genre-ko": "동화원작 영화",
    "genre-en": "Movies based on childrens books"
  },
  {
    "code": "6796",
    "genre-ko": "0-2세 영화",
    "genre-en": "Movies for ages 0 to 2"
  },
  {
    "code": "6962",
    "genre-ko": "11-12 영화",
    "genre-en": "Movies for ages 11 to 12"
  },
  {
    "code": "6218",
    "genre-ko": "2-4 영화",
    "genre-en": "Movies for ages 2 to 4"
  },
  {
    "code": "5455",
    "genre-ko": "5-7 영화",
    "genre-en": "Movies for ages 5 to 7"
  },
  {
    "code": "561",
    "genre-ko": "8-10 영화",
    "genre-en": "Movies for ages 8 to 10"
  },
  {
    "code": "1701",
    "genre-ko": "음악",
    "genre-en": "Music"
  },
  {
    "code": "90361",
    "genre-ko": "음악 & 콘서트 다큐",
    "genre-en": "Music & Concert Documentaries"
  },
  {
    "code": "13335",
    "genre-ko": "뮤지컬",
    "genre-en": "Musicals"
  },
  {
    "code": "9994",
    "genre-ko": "미스터리",
    "genre-en": "Mysteries"
  },
  {
    "code": "63782",
    "genre-ko": "뉴질랜드 영화",
    "genre-en": "New Zealand Movies"
  },
  {
    "code": "12123",
    "genre-ko": "시대물",
    "genre-en": "Period Pieces"
  },
  {
    "code": "2700",
    "genre-ko": "정치 코미디",
    "genre-en": "Political Comedies"
  },
  {
    "code": "7018",
    "genre-ko": "정치 다큐",
    "genre-en": "Political Documentaries"
  },
  {
    "code": "6616",
    "genre-ko": "정치 드라마",
    "genre-en": "Political Dramas"
  },
  {
    "code": "10504",
    "genre-ko": "정치 스릴러",
    "genre-en": "Political Thrillers"
  },
  {
    "code": "5505",
    "genre-ko": "심리 스릴러",
    "genre-en": "Psychological Thrillers"
  },
  {
    "code": "36103",
    "genre-ko": "괴짜 로맨틱",
    "genre-en": "Quirky Romance"
  },
  {
    "code": "9833",
    "genre-ko": "리얼리티 TV",
    "genre-en": "Reality TV"
  },
  {
    "code": "10005",
    "genre-ko": "종교 다큐",
    "genre-en": "Religious Documentaries"
  },
  {
    "code": "3278",
    "genre-ko": "락 & 팝 콘서트",
    "genre-en": "Rock & Pop Concerts"
  },
  {
    "code": "5475",
    "genre-ko": "로맨틱 코메디",
    "genre-en": "Romantic Comedies"
  },
  {
    "code": "1255",
    "genre-ko": "로맨틱 드라마",
    "genre-en": "Romantic Dramas"
  },
  {
    "code": "502675",
    "genre-ko": "인기 로맨틱",
    "genre-en": "Romantic Favorites"
  },
  {
    "code": "7153",
    "genre-ko": "해외 로맨틱 영화",
    "genre-en": "Romantic Foreign Movies"
  },
  {
    "code": "9916",
    "genre-ko": "로맨틱 독립 영화",
    "genre-en": "Romantic Independent Movies"
  },
  {
    "code": "8883",
    "genre-ko": "로맨틱 영화",
    "genre-en": "Romantic Movies"
  },
  {
    "code": "11567",
    "genre-ko": "러시아 영화",
    "genre-en": "Russian"
  },
  {
    "code": "6998",
    "genre-ko": "사탄 이야기",
    "genre-en": "Satanic Stories"
  },
  {
    "code": "4922",
    "genre-ko": "풍자",
    "genre-en": "Satires"
  },
  {
    "code": "9292",
    "genre-ko": "스칸디나비아 영화",
    "genre-en": "Scandinavian Movies"
  },
  {
    "code": "1492",
    "genre-ko": "공상과학 & 판타지",
    "genre-en": "Sci-Fi & Fantasy"
  },
  {
    "code": "6926",
    "genre-ko": "공상과학 & 어드벤쳐",
    "genre-en": "Sci-Fi Adventure"
  },
  {
    "code": "3916",
    "genre-ko": "공상과학 드라마",
    "genre-en": "Sci-Fi Dramas"
  },
  {
    "code": "1694",
    "genre-ko": "공상과학 공포 영화",
    "genre-en": "Sci-Fi Horror Movies"
  },
  {
    "code": "11014",
    "genre-ko": "공상과학 스릴러",
    "genre-en": "Sci-Fi Thrillers"
  },
  {
    "code": "2595",
    "genre-ko": "과학 & 자연 다큐",
    "genre-en": "Science & Nature Documentaries"
  },
  {
    "code": "52780",
    "genre-ko": "과학 & 자연 TV",
    "genre-en": "Science & Nature TV"
  },
  {
    "code": "9702",
    "genre-ko": "스크루볼 코메디",
    "genre-en": "Screwball Comedies"
  },
  {
    "code": "5012",
    "genre-ko": "쇼비즈 드라마",
    "genre-en": "Showbiz Dramas"
  },
  {
    "code": "13573",
    "genre-ko": "쇼비즈 뮤지컬",
    "genre-en": "Showbiz Musicals"
  },
  {
    "code": "53310",
    "genre-ko": "사일런트 영화",
    "genre-en": "Silent Movies"
  },
  {
    "code": "10256",
    "genre-ko": "슬랩스틱 코메디",
    "genre-en": "Slapstick Comedies"
  },
  {
    "code": "8646",
    "genre-ko": "슬래셔 & 연쇄살인범 영화",
    "genre-en": "Slasher and Serial Killer Movies"
  },
  {
    "code": "12549",
    "genre-ko": "축구 영화",
    "genre-en": "Soccer Movies"
  },
  {
    "code": "3675",
    "genre-ko": "사회 & 문화 다큐",
    "genre-en": "Social & Cultural Documentaries"
  },
  {
    "code": "3947",
    "genre-ko": "사회 이슈 드라마",
    "genre-en": "Social Issue Dramas"
  },
  {
    "code": "9196",
    "genre-ko": "동남아시아 영화",
    "genre-en": "Southeast Asian Movies"
  },
  {
    "code": "58741",
    "genre-ko": "스페인 영화",
    "genre-en": "Spanish Movies"
  },
  {
    "code": "2760",
    "genre-ko": "영성 다큐",
    "genre-en": "Spiritual Documentaries"
  },
  {
    "code": "9327",
    "genre-ko": "스포츠 & 피트니스",
    "genre-en": "Sports & Fitness"
  },
  {
    "code": "5286",
    "genre-ko": "스포츠 & 코메디",
    "genre-en": "Sports Comedies"
  },
  {
    "code": "180",
    "genre-ko": "스포츠 다큐",
    "genre-en": "Sports Documentaries"
  },
  {
    "code": "7243",
    "genre-ko": "스포츠 드라마",
    "genre-en": "Sports Dramas"
  },
  {
    "code": "4370",
    "genre-ko": "스포츠 영화",
    "genre-en": "Sports Movies"
  },
  {
    "code": "10702",
    "genre-ko": "스파이 액션 & 어드벤쳐",
    "genre-en": "Spy Action & Adventure"
  },
  {
    "code": "9147",
    "genre-ko": "스파이 스릴러",
    "genre-en": "Spy Thrillers"
  },
  {
    "code": "55774",
    "genre-ko": "무대 뮤지컬",
    "genre-en": "Stage Musicals"
  },
  {
    "code": "11559",
    "genre-ko": "스탠드업 코메디",
    "genre-en": "Stand-up Comedy"
  },
  {
    "code": "35800",
    "genre-ko": "에로틱 로맨틱 영화",
    "genre-en": "Steamy Romantic Movies"
  },
  {
    "code": "8008",
    "genre-ko": "에로틱 공상과학 & 판타지",
    "genre-en": "Steamy Sci-Fi & Fantasy"
  },
  {
    "code": "972",
    "genre-ko": "에로틱 스릴러",
    "genre-en": "Steamy Thrillers"
  },
  {
    "code": "42023",
    "genre-ko": "초자연 공포 영화",
    "genre-en": "Supernatural Horror Movies"
  },
  {
    "code": "11140",
    "genre-ko": "초자연 스릴러",
    "genre-en": "Supernatural Thrillers"
  },
  {
    "code": "6384",
    "genre-ko": "최루 영화",
    "genre-en": "Tearjerkers"
  },
  {
    "code": "3519",
    "genre-ko": "십대 코메디",
    "genre-en": "Teen Comedies"
  },
  {
    "code": "9299",
    "genre-ko": "십대 드라마",
    "genre-en": "Teen Dramas"
  },
  {
    "code": "52147",
    "genre-ko": "십대 공포",
    "genre-en": "Teen Screams"
  },
  {
    "code": "60951",
    "genre-ko": "십대 TV Show",
    "genre-en": "Teen TV Shows"
  },
  {
    "code": "8933",
    "genre-ko": "스릴러",
    "genre-en": "Thrillers"
  },
  {
    "code": "1159",
    "genre-ko": "여행 & 모험 다큐",
    "genre-en": "Travel & Adventure Documentaries"
  },
  {
    "code": "10673",
    "genre-ko": "TV 액션 & 어드벤쳐",
    "genre-en": "TV Action & Adventure"
  },
  {
    "code": "11177",
    "genre-ko": "TV 카툰",
    "genre-en": "TV Cartoons"
  },
  {
    "code": "10375",
    "genre-ko": "TV 코메디",
    "genre-en": "TV Comedies"
  },
  {
    "code": "10105",
    "genre-ko": "TV 다큐",
    "genre-en": "TV Documentaries"
  },
  {
    "code": "11714",
    "genre-ko": "TV 드라마",
    "genre-en": "TV Dramas"
  },
  {
    "code": "83059",
    "genre-ko": "TV 공포",
    "genre-en": "TV Horror"
  },
  {
    "code": "4366",
    "genre-ko": "TV 미스터리",
    "genre-en": "TV Mysteries"
  },
  {
    "code": "1372",
    "genre-ko": "TV 공상과학 & 판타지",
    "genre-en": "TV Sci-Fi & Fantasy"
  },
  {
    "code": "83",
    "genre-ko": "TV Show",
    "genre-en": "TV Shows"
  },
  {
    "code": "9472",
    "genre-ko": "도시 & 댄스 콘서트",
    "genre-en": "Urban & Dance Concerts"
  },
  {
    "code": "75804",
    "genre-ko": "뱀파이어 공포 영화",
    "genre-en": "Vampire Horror Movies"
  },
  {
    "code": "75930",
    "genre-ko": "웨어울프 공포 영화",
    "genre-en": "Werewolf Horror Movies"
  },
  {
    "code": "7700",
    "genre-ko": "서부 영화",
    "genre-en": "Westerns"
  },
  {
    "code": "2856",
    "genre-ko": "음악 콘서트",
    "genre-en": "World Music Concerts"
  },
  {
    "code": "75405",
    "genre-ko": "좀비 공포 영화",
    "genre-en": "Zombie Horror Movies"
  }
]